export default "__VITE_ASSET__554f89d4__"